import { useQuery } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import { toApiDateParams } from '../utils/dateRange';
import type { ChartDataPoint } from '../types';
import type { DateRange } from './useDateRangeFilter';

export const CHART_QUERY_KEY = ['contabilidad', 'chart'] as const;

interface ChartData {
  chartData: ChartDataPoint[];
  chartDataUSD: ChartDataPoint[];
}

export function useChartData(range: DateRange | null = null) {
  const params = toApiDateParams(range);

  const { data, isLoading, error } = useQuery<ChartData>({
    queryKey: [...CHART_QUERY_KEY, params.fecha_inicio ?? null, params.fecha_fin ?? null],
    queryFn: () => contabilidadService.getChartData(params),
    staleTime: 1000 * 60 * 5,
  });

  return {
    chartData: data?.chartData ?? [],
    chartDataUSD: data?.chartDataUSD ?? [],
    isLoading,
    error,
  };
}
